import { useEffect, useRef, useState } from "react";
import { Link } from "react-router-dom";
import { MessageSquareWarning, ChevronRight } from "lucide-react";
import api from "@/lib/api";

// Players on this session the coach still owes feedback to; each links straight to their form.
export function AwaitingFeedbackList({ roster, highlight }) {
  const [rows, setRows] = useState([]);
  const ref = useRef(null);
  useEffect(() => {
    const ids = new Set((roster || []).map((p) => p.booking_id).filter(Boolean));
    api.get("/me/coach/pending-feedback").then((r) => setRows((r.data.items || []).filter((it) => ids.has(it.booking_id)))).catch(() => setRows([]));
  }, [roster]);
  useEffect(() => { if (highlight && rows.length) ref.current?.scrollIntoView({ behavior: "smooth", block: "start" }); }, [highlight, rows.length]);
  if (!rows.length) return null;
  return (
    <div ref={ref} className={`card-surface p-5 border-l-4 border-[#FF4500] space-y-2 scroll-mt-24 ${highlight ? "ring-1 ring-[#FF4500]/60" : ""}`} data-testid="session-awaiting-feedback">
      <div className="flex items-center gap-2 text-[#FF4500] font-bold text-sm">
        <MessageSquareWarning className="w-4 h-4" /> Awaiting feedback: {rows.length} player{rows.length === 1 ? "" : "s"}
      </div>
      {rows.map((it) => (
        <Link key={`${it.booking_id}-${it.student_id}`} to={`/coach/feedback?booking=${it.booking_id}&student=${it.student_id}`}
          data-testid={`awaiting-feedback-${it.student_id}`}
          className="flex items-center justify-between gap-3 py-2.5 px-3 -mx-1 rounded-lg hover:bg-[#1A1A1A] transition-colors">
          <span className="text-sm font-semibold">{it.student_name || "Player"}</span>
          <span className="text-xs uppercase tracking-wider text-[#CCFF00] inline-flex items-center gap-1">Give feedback <ChevronRight className="w-3.5 h-3.5" /></span>
        </Link>
      ))}
    </div>
  );
}
